import Vue from 'vue'

import ContentPadding from '@/components/shared-layout/ContentPadding'
import Panel from '@/components/shared-layout/Panel'

Vue.component('content-padding', ContentPadding)
Vue.component('panel', Panel)
